/* eslint-disable react/no-multi-comp */
import React from "react";
import { ReactDataGrid } from "rhombus-react";
import classNames from "classnames";

const { Row } = ReactDataGrid;

class CustomRow extends Row {

	render(...args) {
		var superElement = Row.prototype.render.apply(this, args)
			, style = {
				height: this.getRowHeight(this.props),
				overflow: "hidden",
			}
			, { isActive, idx } = this.props;

		let pendoClass = "";

		if(this.props?.gridType === "creative"){
			pendoClass = `pendo--${this.props.row.adType}`;
		}

		// Active rows stay highlighted even when not selected
		const className = classNames(
			"react-grid-Row",
			{
				[pendoClass]:true,
				"is-active": isActive,
				"react-grid-Row--even": idx % 2 === 0, // eslint-disable-line no-magic-numbers
				"react-grid-Row--odd": idx % 2 === 1, // eslint-disable-line no-magic-numbers
			}
		);

		// clone the element returned by the superclass (Row)
		// and override its style with one without `contain: 'layout'`
		return React.cloneElement(superElement, { style, className });
	}

}

export default class CustomRowRenderer extends React.Component {

	setScrollLeft = (scrollBy) => {
		this.row.setScrollLeft(scrollBy);
	}

	render() {
	// using my custom row
		return <CustomRow ref={node => this.row = node} {...this.props} isSelected={this.props.row.isSelected} isActive={this.props.row.isActive} />;
	}

}

export class CreativeRowRenderer extends React.Component {

	setScrollLeft = (scrollBy) => {
		this.row.setScrollLeft(scrollBy);
	}

	render() {
	// using my custom row
		return (
			<CustomRow
				ref={node => this.row = node}
				{...this.props}
				gridType="creative"
				isSelected={this.props.row.isSelected}
				isActive={this.props.row.isActive}
			/>
		);
	}
}

